<template lang="pug">
	v-toolbar(
		:color="colors.primary"
		dark
		)
		.icons-container
			//- v-btn.mr-3(
				icon
				@click="$emit('menu')"
				)
				v-icon menu	
			v-btn.mr-3(
				icon 
				v-if="showSale"
				@click="$emit('sale')"
				)
				v-icon shopping_cart	
			v-btn.mr-3(
				icon 
				v-if="showCustomer"
				@click="$emit('customer')"
				)
				v-icon person	
			v-btn.mx-2(
				icon 
				v-if="showSearch"
				@click="$emit('search')"
				)
				v-icon search	
			v-btn.mx-2(
				icon 
				v-if="showSearch"
				@click="$emit('sales:list')"
				)
				v-icon view_list	
			v-btn.mx-2(
				icon 
				v-if="showSearch"
				@click="$emit('receivable:list')"
				)
				v-icon card_travel	
</template>

<script>
export default {
    props: {
        showSearch: {
            type: Boolean,
            default: false,
        },
        showCustomer: {
            type: Boolean,
            default: false,
        },
        showSale: {
            type: Boolean,
            default: false,
        },
    },
}
</script>

<style lang="scss" scoped>
.icons-container {
    display: flex;
    justify-content: flex-start;
    width: 100%;
}
</style>
